// Red de seguridad del redirect de Entra (`onapulse://auth`).
//
// En el flujo normal NO se usa: el navegador devuelve el código y lo recoge
// expo-web-browser dentro de la propia pantalla de login. Pero si Android mata
// la app mientras la pestaña de Microsoft está abierta (móvil con poca RAM), al
// volver el sistema arranca en frío con esa URL y expo-router la resolvería a
// «página no encontrada». Esta ruta existe para que, en ese caso, la persona
// aterrice en la portada en vez de en un error — con la sesión sin completar,
// la puerta de login le pedirá entrar otra vez, que es lo correcto.
import { Redirect } from 'expo-router';

export default function AuthRedirect() {
  return <Redirect href="/" />;
}
